import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL, handleWhatsAppClick } from "../../lib/site";

export const FinalCTA = () => {
    return (
        <section id="contato" data-testid="final-cta-section" className="relative py-28 lg:py-40 bg-[#9f1e1e] text-[#F5F4F2] overflow-hidden">
            <div
                aria-hidden
                className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full opacity-25"
                style={{ background: "radial-gradient(circle at 50% 50%, #D8B7B1 0%, transparent 70%)" }}
            />
            <div
                aria-hidden
                className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full opacity-15"
                style={{ background: "radial-gradient(circle at 50% 50%, #B7A6B0 0%, transparent 70%)" }}
            />

            <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center reveal">
                <p className="overline text-[#F5F4F2]/70 mb-6">Se essa mensagem te tocou</p>
                <h2 className="font-display text-[2.75rem] sm:text-6xl lg:text-[5.5rem] leading-[1.02] tracking-tight">
                    Talvez seja o momento de
                    <span className="block italic text-[#D8B7B1]"> escrever um novo capítulo.</span>
                </h2>
                <p className="mt-10 max-w-2xl mx-auto text-lg lg:text-xl leading-relaxed text-[#F5F4F2]/85">
                    Você merece viver com mais conexão e propósito. Envie uma mensagem agora — respondo
                    pessoalmente cada contato, com a mesma escuta que ofereço dentro do consultório.
                </p>

                <a
                    href={WHATSAPP_URL}
                    onClick={handleWhatsAppClick}
                    data-testid="final-cta-whatsapp"
                    className="inline-flex items-center gap-3 mt-12 px-9 py-5 bg-[#F5F4F2] text-[#9f1e1e] font-medium tracking-wide hover:bg-[#D8B7B1] transition-all duration-500 hover:translate-y-[-2px] shadow-2xl"
                    style={{ borderRadius: "2px" }}
                >
                    Falar com a Luara no WhatsApp
                    <ArrowRight className="w-5 h-5" strokeWidth={1.5} />
                </a>

                <p className="mt-8 text-sm text-[#F5F4F2]/60 tracking-wide">
                    Atendimento online · Brasília (Asa Sul) presencial
                </p>
            </div>
        </section>
    );
};
